import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { seoData } from "../../data/SeoData";

function SEOController() {
  const location = useLocation();
  const pathKey = location.pathname;

  useEffect(() => {
    if (pathKey.includes("/news/")) {
      return;
    }
    // This ensures the effect runs after each route change
    const seoInfo = seoData[pathKey] || seoData["/"];

    // Directly manipulate document head as a fallback
    document.title = seoInfo.title;

    // Update meta tags
    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement("meta");
      descMeta.setAttribute("name", "description");
      document.head.appendChild(descMeta);
    }
    descMeta.setAttribute("content", seoInfo.description);

    // Keywords meta
    if (seoInfo.keywords) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (!keywordsMeta) {
        keywordsMeta = document.createElement("meta");
        keywordsMeta.setAttribute("name", "keywords");
        document.head.appendChild(keywordsMeta);
      }
      keywordsMeta.setAttribute("content", seoInfo.keywords);
    }
  }, [location.pathname, pathKey]);

  // Still return Helmet for React way
  const seoInfo = seoData[location.pathname] || seoData["/"];

  if (pathKey.includes("/news/")) {
    return;
  }

  return (
    <Helmet key={location.pathname}>
      <title>{seoInfo.title}</title>
      <meta name="description" content={seoInfo.description} />
      {seoInfo.keywords && <meta name="keywords" content={seoInfo.keywords} />}
    </Helmet>
  );
}

export default SEOController;
